<div>
  <div *ngIf="showHeader">
    <div>Social Media</div>
  </div>
  <div
    [ngClass]="{
      '!px-0': !showHeader
    }"
  >
    <form [formGroup]="socialMediasForm" class="profile-content-layout">
      <ng-template [ngIf]="socialMediasFormArray?.controls?.length ?? 0 > 0">
        <div
          class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-4"
          formArrayName="socialMedias"
          *ngFor="let group of socialMediasFormArray.controls; let i = index"
        >
          <div class="flex-1">
            <mat-form-field
              [formGroupName]="i"
              class="inline-input-select w-full"
            >
              <mat-label>Social Media</mat-label>
              <input
                matInput
                formControlName="socialMediaUrl"
                [readonly]="keepDisableSaveBtn"
              />
              <mat-select
                formControlName="socialMediaType"
                [disabled]="keepDisableSaveBtn"
                [(ngModel)]="socialMediaTypes[0].name"
              >
                <mat-option
                  *ngFor="let socialMediaType of socialMediaTypes"
                  [value]="socialMediaType.name"
                  >{{ socialMediaType.name }}</mat-option
                >
              </mat-select>
              <mat-error>social media is invalid</mat-error>
            </mat-form-field>
          </div>
          <div class="flex gap-2 w-full sm:w-auto sm:flex-shrink-0">
            <button
              [disabled]="!canDelete"
              (click)="confirmDelete(group, i)"
              tix-button
              color="light"
              class="flex-1 sm:flex-none"
            >
              <tix-icon svgIcon="trash"></tix-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </form>

    <button
      matRipple
      class="flex items-center space-x-1 text-primary text-xs"
      (click)="addNewSocialMedia()"
      [disabled]="!canAdd"
    >
      <span class="material-icons">add</span>
      <span class="text-sm hover:underline"> Add another</span>
    </button>
  </div>
  <div
    [ngClass]="{
      'flex flex-col sm:flex-row gap-3 sm:gap-4 mt-3 justify-end': true,
      '!px-0 !py-0': !showHeader
    }"
  >
    <div class="flex-1 sm:flex-none self-center">
      <ng-content select="[secondaryAction]"></ng-content>
    </div>
    <button
      mat-button
      (click)="handleSaveClick()"
      class="w-full sm:w-auto min-w-[160px] px-6 py-1.5 sm:py-1 bg-primary text-white font-medium"
      [ngClass]="[
        !socialMediasForm.valid || !socialMediasForm.dirty
          ? 'cursor-not-allowed'
          : 'cursor-pointer',
        !socialMediasForm.valid || (!socialMediasForm.dirty && !isloading)
          ? 'hover:bg-gray-300 hover:text-gray-700 hover:opacity-50'
          : 'hover:bg-primary-700'
      ]"
      [disabled]="
        !socialMediasForm.valid ||
        !socialMediasForm.dirty ||
        isloading ||
        !canEdit
      "
    >
      <div *ngIf="!isloading" class="flex items-center justify-center">
        <span class="material-icons-outlined mr-2 text-lg">save</span>
        <span>Save Changes</span>
      </div>
      <div *ngIf="isloading" class="flex items-center justify-center space-x-2">
        <span class="mr-2" *tixBtnLoading="isloading"></span>
        <span>Loading</span>
      </div>
    </button>
  </div>
</div>
